import { Box } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { OutfitTitle } from '@/components/blocks/ModalOutfits/parts/OutfitTitle';
import { useModalOutfitsContext } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';

export const OutfitHeader = () => {
	const { onClose } = useModalOutfitsContext();

	return (
		<Box
			sx={{
				display: 'flex',
				flex: 1,
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'center',
				minHeight: { xs: '58px !important', md: '44px !important' },
				gap: '10px',
			}}
		>
			<OutfitTitle />
			<ClearIcon
				color="inherit"
				fontSize="medium"
				sx={{
					cursor: 'pointer',
					marginRight: '0px',
					position: 'absolute',
					right: { xs: '10px', md: '15px' },
					top: { xs: '10px', md: '15px' },
				}}
				onClick={onClose}
			/>
		</Box>
	);
};
